import { Children, type CSSProperties, type ReactNode } from "react";
import "./HomeCarShelf.css";

/** Balance complete rows without dropping or repeating any inventory. */
export function balancedShelfColumns(count: number, maxColumns: number): number[] {
  if (count <= 0) return [];
  const rows = Math.ceil(count / Math.max(1, maxColumns));
  const base = Math.floor(count / rows);
  const largerRows = count % rows;
  return Array.from({ length: rows }, (_, row) => {
    const columns = base + (row < largerRows ? 1 : 0);
    return Array<number>(columns).fill(columns);
  }).flat();
}

type ShelfStyle = CSSProperties & {
  "--shelf-cols-sm": number;
  "--shelf-cols-lg": number;
  "--shelf-cols-xl": number;
};

export default function HomeCarShelf({ children }: { children: ReactNode }) {
  const cards = Children.toArray(children);
  const small = balancedShelfColumns(cards.length, 3);
  const large = balancedShelfColumns(cards.length, 4);
  const extraLarge = balancedShelfColumns(cards.length, 5);

  return (
    <div className="home-car-shelf mt-4 scrollbar-hide">
      {cards.map((card, index) => (
        <div
          className="home-car-shelf-item"
          key={typeof card === "object" && "key" in card ? card.key : index}
          style={{
            "--shelf-cols-sm": small[index],
            "--shelf-cols-lg": large[index],
            "--shelf-cols-xl": extraLarge[index],
          } as ShelfStyle}
        >
          {card}
        </div>
      ))}
    </div>
  );
}